<template>
    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 mt-3 mb-md-3">
        <router-link :to="{ name: 'item-details', params: { itemTitle: item.title, itemId: item._id } }" :title="`${item.title} - aNewItem.com`">
            <div class="card h-100 pr-1 p-md-0">
                <div class="row">

                    <!-- import item photo here -->
                    <div class="col-md-12 col-4">
                        <app-item-photo class="anewitem-img-box rounded mr-n3 mr-md-0" :itemPhotos="item.photos"></app-item-photo>
                    </div>

                    <!-- display item details -->
                    <div class="col-md-12 col-8">
                        <div class="p-md-2">
                            <!-- item notes here -->
                            <p class="anewitem-title mb-2">{{item.title}}</p>
                            <!-- import item price here -->
                            <p class="anewitem-price mb-2"><app-item-price :item="item"></app-item-price></p>
                            <div class="anewitem-condition mt-2">
                                <i class="fas fa-layer-group text-dark-green fa-sm"></i> {{item.category | capitalize}}
                            </div>
                            <div class="anewitem-condition my-1">
                                <i class="fas fa-balance-scale text-dark-green fa-sm"></i> {{item.condition | capitalize}}
                            </div>

                            <!-- import items action btns -->
                            <app-item-action-btns :item="item" :pageName="thePageName"></app-item-action-btns>
                        </div>
                    </div>
                    
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import ItemPhoto from '@/components/general/shared/ItemParts/ItemPhoto.vue'
import ItemPrice from '@/components/general/shared/ItemParts/ItemPrice.vue'
import ItemActionBtns from '@/components/general/pages/itemDetailsParts/ItemActionBtns.vue'

export default {
    name: "Item",
    props: {
        item: {
            type: Object,
            required: true
        },
        pageName: {
            type: String,
            required: false
        },
    },
    computed: {
        thePageName() {
            if(this.pageName) {
                return `${this.pageName}`
            }
            return 'Item'
        }
    },
    components: {
        appItemPhoto: ItemPhoto,
        appItemPrice: ItemPrice,
        appItemActionBtns: ItemActionBtns
    }
}
</script>
